import React, { useEffect, useState } from 'react';
import { fetchVendeursParStatut } from '../../services/vendeurs/vendeurService';
import '../../styles/admin/ListeVendeurValides.css';

const ListeVendeurValides = () => {
  const [utilisateurs, setUtilisateurs] = useState([]);

  useEffect(() => {
    let mounted = true;
    const loadVendeurs = async () => {
      try {
        const data = await fetchVendeursParStatut('valide');
        if (mounted) setUtilisateurs(data);
      } catch (err) {
        console.error('Erreur chargement utilisateurs validés :', err);
      }
    };
    loadVendeurs();
    return () => { mounted = false; };
  }, []);

  return (
    <div className="mes-produits-container">
      <div className="mes-produits-header">
        <h2>Vendeurs validés</h2>
      </div>

      {utilisateurs.length === 0 ? (
        <p>Aucun vendeur validé.</p>
      ) : (
        <div className="table-responsive">
          <table className="mes-produits-table">
            <thead>
              <tr>
                <th>Nom</th>
                <th>Prénom</th>
                <th>Email</th>
                <th>Téléphone</th>
              </tr>
            </thead>
            <tbody>
              {utilisateurs.map((u) => (
                <tr key={u.id}>
                  <td data-label="Nom">{u.nom}</td>
                  <td data-label="Prénom">{u.prenom}</td>
                  <td data-label="Email">{u.email}</td>
                  <td data-label="Téléphone">{u.telephone}</td>
                </tr>
              ))}
            </tbody>
          </table>
        </div>
      )}
    </div>
  );
};

export default ListeVendeurValides;
